/**
 * Stable CSS class names for E2E — Product transfer page.
 */
export const PT = {
    page: 'product-transfer-page',
    loadingSection: 'product-transfer-page__loading-section',
    loadingBar: 'product-transfer-page__loading-bar',
    breadcrumbSection: 'product-transfer-page__breadcrumb-section',

    formSection: 'product-transfer-page__form-section',
    sendPaper: 'product-transfer-page-input--paper-send',
    sendInput: 'product-transfer-page-input--text-model-id',
    sendButton: 'product-transfer-page-input--button-send',

    resultsSection: 'product-transfer-page__results-section',
    resultsTitleWrap: 'product-transfer-page__results-title-wrap',
    resultsTitle: 'product-transfer-page__results-title',
    resultsLoadingWrap: 'product-transfer-page__results-loading-wrap',
    resultsGridWrap: 'product-transfer-page__results-grid-wrap',

    cellResponseIconSuccess: 'product-transfer-page__response-icon--success',
    cellResponseIconError: 'product-transfer-page__response-icon--error',
} as const;

export const ptCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

